// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Third Party
import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { FormAction } from '../../shared/classes/formAction';
import { Helpers } from '../../shared/services/helpers';
import { WebServices } from '../../shared/services/webServices';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '\n<div id="ashMainDiv" class="ash-main-div" data-test-id="content_asset_history">\n\n    <h2 id="ashMainTitle" tabindex="0" class="ash-title-div">Asset Change History</h2>\n\n    <!--Define Content Loading Template -->\n    <ng-template #loading>\n        <div id="ashLoadingDiv" class="ash-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n\n    <!--Render post load content or loading template-->\n    <ng-container *ngIf="!_stillLoadingStuff(); else loading">\n\n        <!--Show Asset Information Block-->\n        <div id="ashAssetInfoDiv" class="ash-ui-cell">\n            <div class="ash-ui-group-lbl" role="heading" aria-label="Asset"><h3>Asset</h3></div>\n            <div style="display:flex;">\n                <div style="font-weight:bold;margin-right:5px;">Asset&nbsp;Code:</div>\n                <div>{{_currentPractice?.practice_code}}</div>\n                <div style="font-weight:bold;margin:0 5px 0 20px;">Asset&nbsp;Name:</div>\n                <div>{{_currentPractice?.practice_name}}</div>\n            </div>\n        </div>\n\n        <div id="ashPageInfoDiv" style="font-style:italic; margin:10px 10px 25px 12px;">The list below contains records of asset changes for a given date.  Select a row and click "View Changes" from the Actions menu to see the values that were changed.</div>\n\n        <!-- Narratives Grid --------------------------------->\n        <cas-grid #assetHistoryGrid\n                  summary="Asset Change History"\n                  [settings]="assetHistoryGridSettings"\n                  (onRefreshClicked)="onGridRefreshClicked()"\n                  (onRowSelectionChanged)="onRowSelectionChanged()"\n                  (onSearch)="onGridSearch($event)">\n        </cas-grid>\n\n\n    </ng-container>\n\n    <!--POPUP INSTANCE CONTAINER-->\n    <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n    <div id="asset_history_page_popups"></div>\n\n    <!--====================-->\n    <!--Asset History Details Popup    -->\n    <!--====================-->\n    <!--Unfortunately this currently has to be duplicated on the public & cpdes page-->\n    <modal #assetHistoryDetailsPopup\n           containerId="asset_history_page_popups"\n           title="Asset History Details ({{_currentSelectedRow?.practice_display}})"\n           label="assetHistoryDetailsPopup"\n           customClass="modal-lg">\n\n        <!--FVT-ID-->\n        <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_main_asset_history_container_details"></section>\n\n        <!-- body -->\n        <section>\n            <!-- Asset History Details Grid --------------------------------->\n            <cas-grid #assetHistoryDetailsGrid\n                      summary="Asset History Details"\n                      [settings]="assetHistoryDetailsGridSettings">\n            </cas-grid>\n        </section>\n\n        <!-- footer -->\n        <footer>\n            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n        </footer>\n    </modal>\n\n\n</div>',
    styles : ['.ash-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.ash-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}.ash-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.ash-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:25px 15px 10px 25px;margin:0 10px;max-width:900px}.ash-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.ash-ui-row{display:flex;margin-bottom:5px}'],
    providers: []
})
export class AssetHistoryComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('assetHistoryGrid') assetHistoryGrid;
    @ViewChild('assetHistoryDetailsPopup') assetHistoryDetailsPopup;
    @ViewChild('assetHistoryDetailsGrid') assetHistoryDetailsGrid;

	//Class wide member reference for the growls control
	growlBox = null;

    
    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'assetHistory.js';
    _disposalFunctions = [];
    _contentLoading = true;

    //Data
    _currentPracticeId = null;
    _currentPractice = null;
    _currentSelectedRow = null;
    _selectedPracticeHistoryIndex = null;
    _practiceHistoryList = [];      //Will contain a *copy* (not a reference) of the history list returned from the server for this asset
    _practiceDifferentialArray = [];

    //Grid settings
    assetHistoryGridSettings = {
        hideClearSelectedButton:true,
        hideSearchBox:false,
        loading:true,
        rowIdentifyForJAWS:true,
        rowIdentityFieldForJAWS:"SysStartTime",
        rowIdentityPrefixForJAWS:"History record selected for date,",
        showCheckboxColumn:true,
        positionAbsolute:false,

        columns: [
            { fieldName:'SysStartTime', display:'Changed Date', width:'10%', minWidth:50, dataType:"date",
                procDataFn: (SysStartTime) => { return moment.utc(SysStartTime).local().format('YYYY-MM-DD h:mm A'); } },
            { fieldName:'last_changed_by', display:'Changed By (ZRoles ID)', width:'90%', minWidth:75 }
        ],
        rows : []
    }

    //Asset History Details Grid settings
    assetHistoryDetailsGridSettings = {
        hideClearSelectedButton: true,
        hideSearchBox: true,
        loading: false,
        rowIdentifyForJAWS: false,
        showCheckboxColumn: false,
        positionAbsolute: false,
        hidePaginationControls: true,
        hideRefreshButton: true,
        maxHeight: 600,
        columns: [
            { fieldName: 'property', display: 'Propertry Name', width: '33%', minWidth: 75, dataType: "string"},
            {
                fieldName: 'oldValue', display: 'Previous Value', width: '33%', minWidth: 75,
                procDataFn: (oldValue, row) => this.dataConversionFunction(oldValue, row)
            },
            {
                fieldName: 'newValue', display: 'Revised Value', width: '33%', minWidth: 75,
                procDataFn: (newValue, row) => this.dataConversionFunction(newValue, row)
            }
        ],
        rows: []
    }


    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        helpers: Helpers,
        route: ActivatedRoute,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Mark everything as loading (grid was already initialized as "loading")
        this.casNavBoxService.ActionsLoading = true;
        this._contentLoading = true;

        //Handle nav menu events
        let disposable = casNavBoxService.OnActionClicked$.subscribe(action => {
            this.navBoxActionClicked(action);
        })

        //Add handler to the disposer
        this._disposalFunctions.push(disposable);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        this._disposalFunctions.map(x => x.unsubscribe());
    }

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.initalizeGrowlBox();

        //Number of async ops this function has left to complete
        var ops = 2;

        //508
        this.set508();

        // PARAMS
        //(note that this is a snapshot and will not change without a page reload)
        //(use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        this._currentPracticeId = this.route.snapshot.params.practiceId;

        //Navbox Setup
        this.setNavBoxActions();

        //Load the asset for display purposes
        this.loadAsset(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });
        
        //Load the history records for this asset
        this.loadAssetHistory(() => {
            if (--ops == 0) { this.ngOnInit_Complete(); }
        });

    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        this._contentLoading = false;
        this.casNavBoxService.ActionsLoading = false;
        this._markGridAsLoading(false);
    }

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer definied in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    // BL FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // dataConversionFunction
    //==================================
    dataConversionFunction(value, row) {
        if (!value) {
            return;
        }
        if (Number.isInteger(Number(value))) {
            return value;
        }
        let isUTC = row.property === "SysStartTime" || row.property === "SysEndTime";
        let validDate = moment(value, moment.ISO_8601, true).isValid();
        if (validDate && isUTC) {
            return moment.utc(value).local().format('YYYY-MM-DD h:mm A');
        }
        if (validDate) {
            return moment.utc(value).format('YYYY-MM-DD');
        }
        return value;
    }

    //==================================
    // loadAsset
    //==================================
    loadAsset(fnOnComplete) {

        //Load the practice for the indicated practiceId
        this.webServices.Get({
            apiPath: "/practices/getPractice",
            args: { practiceId: this._currentPracticeId }
        })
        .then(res => {

            console.log("[{0}:loadAsset():/practices/getPractice] - res:".format(this._componentName), res);

            if (res.data.Success) {
                this._currentPractice = res.data.DTO;
                if (fnOnComplete) { fnOnComplete(); }
            }
            else {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res.data.ErrorMessage));
            }
        })
        .catch(err => {
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
        });
    }

    //==================================
    // loadAssetHistory
    //==================================
    loadAssetHistory(fnOnComplete) {

        //Load the practice for the indicated practiceId
        this.webServices.Get({
            apiPath: "/practices/getPracticeHistoryByPracticeId",
            args: { practiceId: this._currentPracticeId }
        })
        .then(res => {

            console.log("[{0}:loadAssetHistory():/practices/getPracticeHistoryByPracticeId] - res:".format(this._componentName), res);

            if (res.data.Success) {

                //Store a *copy* of the list for later calculations
                //  (Use a copy for the grid to avoid impacting the grid's source data when working on the history list)
                this._practiceHistoryList = this.helpers.deepCopyObject(res.data.DTO);
                console.log("[{0}:practiceHistoryList():".format(this._componentName), this._practiceHistoryList);

                //Use original list for the grid
                this._setGridRows(res.data.DTO);
                if (fnOnComplete) { fnOnComplete(); }
            }
            else {
                this._markGridAsLoading(false);
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(res.data.ErrorMessage));
            }
        })
        .catch(err => {
            this._markGridAsLoading(false);
            this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));
        });
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {

        let actions = [];

        actions.push(new FormAction("act_return_to_assets_list", "Return to Assets List"));
        actions.push(new FormAction("act_open_details", "View Changes"));

        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
    }


    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";
            let el = document.getElementsByClassName("ash-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // navBoxActionClicked
    //==================================
    navBoxActionClicked(action) {

        switch (action.field_name) {

            case "act_return_to_assets_list":
                this.router.navigate(["/cpdes/practices/viewV2"]);
                break;

            case "act_open_details":
                if (!this._currentSelectedRow) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }
                this.openAssetHistoryDetailsPopup();
                break;
        }
    }

    //==================================
    // openAssetHistoryDetailsPopup
    //==================================
    openAssetHistoryDetailsPopup() {
        this.buildDifferential();
        this.assetHistoryDetailsPopup.Open();
        this.assetHistoryDetailsGrid.SetRows(this._practiceDifferentialArray);
    }

    //=================================
    // buildDifferential
    //=================================
    buildDifferential() {
        this.clearDifferential(); // Needed before starting to build.
        this.sortPracticeHistoryList(); // Needed before setting selected practice history index.
        this.setSelectedPracticeHistoryIndex(); // Needed before addingRowsToDifferential.
        this.cycleThroughPropertiesAddingRowsToDifferential();
        console.log(`[${this._componentName}:practiceDifferentialArray():`, this._practiceDifferentialArray);
    }

    //================================
    // clearPracticeDifferential
    //================================
    clearDifferential() {
        this._practiceDifferentialArray = [];
    }

    //==================================
    // sortPracticeHistoryList
    //==================================
    sortPracticeHistoryList() {
        this._practiceHistoryList.sort(this.practiceHistoryListSortingFunction)
    }

    //==================================
    // practiceHistoryListSortingFunction
    //==================================
    practiceHistoryListSortingFunction(a, b) {
        if (a.SysStartTime < b.SysStartTime) {
            return -1;
        }
        if (a.SysStartTime > b.SysStartTime) {
            return 1;
        }
        return 0;
    }

    //=================================
    // setSelectedPracticeHistoryIndex
    //=================================
    setSelectedPracticeHistoryIndex() {
        this._selectedPracticeHistoryIndex = this._practiceHistoryList.findIndex(practiceHistory => practiceHistory.practice_history_id === this._currentSelectedRow.practice_history_id);
    }

    //===============================================
    // cycleThroughPropertiesAddingRowsToDifferential
    //===============================================
    cycleThroughPropertiesAddingRowsToDifferential() {
        let listOfPracticeProperties = Object.keys(this._currentSelectedRow);
        listOfPracticeProperties.forEach(property => {
            // Discard __selected property
            if (property === "__selected") {
                return;
            }

            this.addRowToDifferential(property);
        });
    }

    //==================================
    // addRowToDifferential
    //==================================
    addRowToDifferential(property) {
        let originalDataEntryInPracticeHistory = this._selectedPracticeHistoryIndex === 0;
        let changeInValues = originalDataEntryInPracticeHistory || this.compareProperties(property);
        if (!changeInValues) {
            return;
        }
        let isAnArray = Array.isArray(this._currentSelectedRow[property]);
        if (isAnArray) {
            this.addArrayRow(property, originalDataEntryInPracticeHistory);
            return;
        }
        this.addDefaultRow(property, originalDataEntryInPracticeHistory);
    }

    //==================================
    // compareProperties
    //==================================
    compareProperties(property) {
        if (property) {
            let isAnArray = Array.isArray(this._currentSelectedRow[property]);
            if (isAnArray) {
                return this.compareArrays(property);
            }
        }
        return this._practiceHistoryList[this._selectedPracticeHistoryIndex - 1][property] !== this._currentSelectedRow[property];
    }

    //==================================
    // compareArrays
    //==================================
    compareArrays(property) {
        let previousData = this._practiceHistoryList[this._selectedPracticeHistoryIndex - 1][property];
        let selectedData = this._currentSelectedRow[property];
        previousData.sort();
        selectedData.sort();
        return previousData.toString() !== selectedData.toString();
    }

    //==================================
    // addArrayRow
    //==================================
    addArrayRow(property, originalDataEntryInPracticeHistory) {
        this._practiceDifferentialArray.push({
            property: property,
            oldValue: originalDataEntryInPracticeHistory ? "null" : this._practiceHistoryList[this._selectedPracticeHistoryIndex - 1][property].toString().replaceAll(",", ", "),
            newValue: this._currentSelectedRow[property].toString().replaceAll(",", ", ")
        });
    }

    //==================================
    // addDefaultRow
    //==================================
    addDefaultRow(property, originalDataEntryInPracticeHistory) {
        this._practiceDifferentialArray.push({
            property: property,
            oldValue: originalDataEntryInPracticeHistory ? "null" : this._practiceHistoryList[this._selectedPracticeHistoryIndex - 1][property] ? this._practiceHistoryList[this._selectedPracticeHistoryIndex - 1][property].toString().replaceAll(",", ", ") : "null",
            newValue: this._currentSelectedRow[property] ? this._currentSelectedRow[property].toString().replaceAll(",", ", ") : "null"
        });
    }

    //==================================
    // onGridRefreshClicked
    //==================================
    onGridRefreshClicked() {
        this._markGridAsLoading(true);
        this.assetHistoryGrid.UnselectAllRows(); //To prevent Action Clicks from being executed with stale context
        this.loadAssetHistory(() => {
            this._markGridAsLoading(false);
        });
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged() {
        this._currentSelectedRow = this.assetHistoryGrid.GetFirstSelectedRow();
    }

    //==================================
    // onGridSearch
    //==================================
    onGridSearch(searchText) {

        //Clear any selections
        this.assetHistoryGrid.UnselectAllRows();

        //Grab the screen reader notification element
        var elLive = document.getElementById("accAlertAssertive");

        //This is for readability
        let searchFilterName = "search";
        let applyImmediately = true;

        //If the search box is empty, clear the filter and jump out
        if (!searchText || searchText.length == 0){
            this.assetHistoryGrid.ClearFilter(searchFilterName, applyImmediately);
            if (elLive) { elLive.innerText = "Search cleared, grid updated"; }
            return;
        }

        //Create the filter function
        let fnFilter = (row) => {
            return (row.SysStartTime.toLowerCase().indexOf(searchText) >= 0 || row.last_changed_by.toLowerCase().indexOf(searchText) >= 0);
        };

        //Set the "search" filter on the grid
        this.assetHistoryGrid.SetFilter(searchFilterName, fnFilter, applyImmediately);
        
        //Notify screen readers
        if (elLive) { elLive.innerText = "Search complete, grid updated"; }
    
    }


    // BOILER PLATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI() {
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI() {
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.assetHistoryGrid){
            this.assetHistoryGrid.MarkAsLoading(isLoading);
        }
        else{
            this.assetHistoryGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here we'll test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.assetHistoryGrid){
            this.assetHistoryGrid.SetRows(data);
        }
        else{
            this.assetHistoryGridSettings.rows = data;
        }
    }

    //==================================
    // _stillLoadingStuff
    //==================================
    _stillLoadingStuff() {
        return this.casNavBoxService.ActionsLoading == true || this._contentLoading == true;
    }

}//component

